import LogsLayout from "components/logs/LogsLayout";

function LogsPage(props: any) {

    return (
        <LogsLayout props={props} />
    );
}

export default LogsPage;